export default {
  card: {
    male: 'Male',
    female: 'Female',
    notDisclosed: 'Prefer not to say',
    unknown: 'Unknown',
    createTime: 'Created At',
    changeTime: 'Changed At',
    playTime: 'Play Time',
    projectName: 'Project Name',
    verifyAsset: 'Redeemed Asset',
    shopName: 'Charging Store',
    operatorName: 'Operator',
    operationTime: 'Operation Time',
    operateShopName: 'Operating Store',
    changeShopName: 'Change Store',
    changerName: 'Changed By',
    changeType: 'Change Type',
    changeContent: 'Change Content',
    operationType: 'Operation Type',
    operationContent: 'Operation Content',
    source: 'Source',
  },
  asset: {
    assetType: 'Asset Type',
    assetTypeCountTicket: 'Count Ticket',
    assetTypeMonthYearTicket: 'Monthly/Annual Ticket',
    allAssetTypes: 'All Asset Types',
    productName: 'Product Name',
    productType: 'Product Type',
    ticketStatus: 'Ticket Status',
    totalCount: 'Total Uses',
    remainingCount: 'Remaining Uses',
    acquiredTime: 'Acquired At',
    effectiveTime: 'Effective At',
    expireTime: 'Expires At',
    activationMethod: 'Activation Method',
    statusAvailable: 'Available',
    statusUsedUp: 'Used Up',
    statusExpired: 'Expired',
    effectBuyAfter: 'Effective Immediately After Purchase',
    effectFirstUse: 'Effective Upon First Use',
    effectDaysAfter: 'Effective After Specified Days',
    effectCustom: 'Effective at Custom Time',
  },
  order: {
    purchaseTime: 'Purchase Time',
    consumeShop: 'Store',
    orderAmount: 'Order Amount',
    discountAmount: 'Discount Amount',
    paidAmount: 'Paid Amount',
    salesChannel: 'Sales Channel',
    viewDetails: 'View Details',
  },
  profile: {
    male: 'Male',
    female: 'Female',
    notDisclosed: 'Prefer not to say',
  },
};
